export default __webpack_public_path__ + "static/media/Jack.6fc4a834.png";